import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { WsButton, WsColors, WsDialog, WsTypography, WsTypoVariants } from 'wisestep-base';

import WsCheckmarkSelect from '../../../components/WsCheckmarkSelect';
import { entityTypeOptions } from '../helper/ClientFormHelper';

interface UpdateClientEntityTypePopUpProps {
  open: boolean;
  currentEntityTypes: string[];
  entity: 'client';
  isLoading?: boolean;
  onSubmit: (entityTypes: string[]) => void;
  onCancel: () => void;
}

const UpdateClientEntityTypePopUp = ({
  open,
  currentEntityTypes,
  entity,
  isLoading = false,
  onSubmit,
  onCancel,
}: UpdateClientEntityTypePopUpProps) => {
  const title = entity === 'client' ? 'Update Client Entity Type' : 'Update Contact Entity Type';
  const label = entity === 'client' ? 'Client Entity Type' : 'Contact Entity Type';

  const defaultSelectedOptions = entityTypeOptions.filter((opt) =>
    currentEntityTypes.includes(opt.value)
  );

  const formMethods = useForm({
    defaultValues: {
      entityType: defaultSelectedOptions.map((opt) => opt.value),
    },
  });

  const handleSubmit = (data: { entityType: any[] }) => {
    const values = (data.entityType || []).map((item) => item.value ?? item);
    onSubmit(values);
  };

  return (
    <WsDialog onClose={onCancel} openDialog={open}>
      <FormProvider {...formMethods}>
        <Box component="form" onSubmit={formMethods.handleSubmit(handleSubmit)}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <DialogTitle>{title}</DialogTitle>
            <IconButton
              onClick={onCancel}
              sx={{
                color: WsColors.GreyBlack,
                mr: 2,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider orientation="horizontal" />
          <Box mt={2} ml={7}>
            <WsTypography variant={WsTypoVariants.BODY1}>{label}</WsTypography>
          </Box>
          <DialogContent sx={{ mb: 2, pl: 7, width: '80%' }}>
            <WsCheckmarkSelect
              name="entityType"
              options={entityTypeOptions}
              getLabel={(option) => option.label}
              getValue={(option) => option.value}
            />
          </DialogContent>
          <Divider orientation="horizontal" />
          <DialogActions sx={{ mr: 2, mb: 1 }}>
            <WsButton
              type="submit"
              disabled={isLoading}
              endIcon={isLoading ? <CircularProgress size={17} color="secondary" /> : <></>}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </WsButton>
          </DialogActions>
        </Box>
      </FormProvider>
    </WsDialog>
  );
};

export default UpdateClientEntityTypePopUp;
